/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Typography, Grid, Button, Avatar, AvatarGroup } from '@mui/material';

const style = {
  bgcolor: 'rgba(144, 202, 249, 0.1)',
  boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;',
  borderRadius: '5px',
  justifyContent: 'space-between',
  height: '100%',
};

const btnStyle = {
  bgcolor: 'rgba(144, 202, 249, 0.15)',
  color: '#FFF',
  borderRadius: '0 0 5px 5px',
  boxShadow: 'none !important',
};

export const DepartmentCard = (props) => {
  return (
    <Grid item xs={6} sm={4} md={4} lg={3}>
      <Grid container direction="column" sx={style}>
        <Grid item sx={{ mt: 2, py: 1, px: 5, textAlign: 'justify' }}>
          <Typography
            sx={{ lineHeight: '1', fontWeight: 500, mb: 1.4 }}
            margin={0}
            variant="subtitle1"
            align="center"
          >
            {props.title}
          </Typography>
          <Typography variant="caption">{props.desc}</Typography>
        </Grid>
        <Grid>
          <AvatarGroup
            sx={{ justifyContent: 'center', my: 2 }}
            total={props.members.length}
            spacing={'small'}
            max={6}
          >
            {props.members.map((member, index) => (
              <Avatar key={index} />
            ))}
          </AvatarGroup>

          <Button fullWidth sx={btnStyle} onClick={props.onClick}>
            View
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
